// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "2cf0dc6271376b0225c75628a4207d5f0c575d65/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"36bf3700","98":"aa14b4c2","130":"3099d24f","440":"486bdddc","581":"a474c96c","731":"853d8457","822":"5ed7a9db"}[chunkId] + ".chunk.js";
};